import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import InputAdornment from "@mui/material/InputAdornment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Iconos
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BusinessIcon from "@mui/icons-material/Business";
import StorefrontIcon from "@mui/icons-material/Storefront";
import NotesIcon from "@mui/icons-material/Notes";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import ItemsFormulario from "./ItemsFormulario";
import { facturar } from "../functions";
import DatosFacturacion from "./DatosFacturacion";

const BRAND = "#2471A3";

export default function Items(props) {
  const {
    cliente,
    selectorSucursal,
    remitosAFacturar = [],
    preparar,
    sucFacturadora,
    leyenda,
    setLeyenda,
    ocs,
    setOcs,
    letra,
    remitosTexto,
    setRemitosTexto,
    itemsForm,
    setItemsForm,
    onlyTable,
    setFacturarDeshabilitado,
    confirmar,
  } = props;

  useEffect(() => {
    if (remitosAFacturar && remitosAFacturar.length > 0) {
      const inicializados = remitosAFacturar.map((item) => {
        const cantidad = Number(item.cantidad_total ?? item.cantidad ?? 0);
        const pSin = item.precioSinIva || "";
        const total = pSin ? (cantidad * parseFloat(pSin)).toFixed(2) : "0.00";

        return {
          ...item,
          precioSinIva: pSin,
          precioConIva: item.precioConIva || "",
          totalItem: total,
        };
      });
      setItemsForm(inicializados);
    } else {
      setItemsForm([]);
    }
  }, [remitosAFacturar]);

  useEffect(() => {
    if (remitosAFacturar && remitosAFacturar?.length > 0 && setRemitosTexto) {
      const arrayRemitos = remitosAFacturar.flatMap(
        (item) => item.remitos_incluidos || []
      );
      const remitosUnicos = [...new Set(arrayRemitos)].join(", ");
      setRemitosTexto(remitosUnicos);
    }
  }, [remitosAFacturar, setRemitosTexto]);

  const handlePrecioChange = (index, field, value) => {
    const regex = /^\d*\.?\d{0,4}$/;
    if (!regex.test(value) && value !== "") return;

    const newItems = [...itemsForm];
    const item = { ...newItems[index] };
    // const porcIva = Number(item.valor_iva || item.iva || 0);
    const valorIva = Number(item.valor_iva || item.iva || 0);

    const cantidad = Number(item.cantidad_total ?? item.cantidad ?? 0);

    let pSinCalculado = 0;

    if (field === "sinIva") {
      item.precioSinIva = value;
      if (value !== "" && !isNaN(parseFloat(value))) {
        pSinCalculado = parseFloat(value);
        // const valCon = pSinCalculado * (1 + porcIva / 100);
        const valCon = pSinCalculado * valorIva;
        item.precioConIva = valCon.toFixed(4);
      } else {
        item.precioConIva = "";
      }
    } else if (field === "conIva") {
      item.precioConIva = value;
      if (value !== "" && !isNaN(parseFloat(value))) {
        const valCon = parseFloat(value);
        // pSinCalculado = porcIva > 0 ? valCon / (1 + porcIva / 100) : valCon;
        pSinCalculado = valorIva > 0 ? valCon / valorIva : valCon;

        item.precioSinIva = pSinCalculado.toFixed(4);
      } else {
        item.precioSinIva = "";
      }
    }

    item.totalItem = (cantidad * pSinCalculado).toFixed(2);

    newItems[index] = item;
    setItemsForm(newItems);
  };

  const tienePreciosIncompletos =
    itemsForm.length === 0 ||
    itemsForm.some(
      (item) => !item.precioSinIva || parseFloat(item.precioSinIva) <= 0
    );

  useEffect(() => {
    const facturarDeshabilitado = tienePreciosIncompletos || !sucFacturadora;
    setFacturarDeshabilitado(facturarDeshabilitado);
  }, [itemsForm, sucFacturadora]);

  if (onlyTable) {
    return (
      <ItemsFormulario
        cliente={cliente}
        selectorSucursal={selectorSucursal}
        letra={letra}
        itemsForm={itemsForm}
        handlePrecioChange={handlePrecioChange}
        leyenda={leyenda}
        setLeyenda={setLeyenda}
        ocs={ocs}
        setOcs={setOcs}
        remitosTexto={remitosTexto}
        confirmar={confirmar}
        facturarDeshabilitado={facturar}
      />
    );
  }

  return (
    <Container maxWidth="xl" disableGutters sx={{ mt: 1, mb: 1 }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
          bgcolor: "background.paper",
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 1.75,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            background: `linear-gradient(90deg, ${BRAND} 0%, #1B5178 100%)`,
            color: "#fff",
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar
              sx={{
                bgcolor: "rgba(255,255,255,0.18)",
                width: 38,
                height: 38,
              }}
            >
              <ReceiptLongIcon />
            </Avatar>
            <Box>
              <Typography sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                Resumen de facturación
              </Typography>
              <Typography sx={{ opacity: 0.85, fontSize: 12.5 }}>
                Revisá los datos del comprobante e ingresá los precios unitarios
              </Typography>
            </Box>
          </Stack>
          <Chip
            label={`${itemsForm.length} ítem(s)`}
            size="small"
            sx={{
              bgcolor: "rgba(255,255,255,0.16)",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid rgba(255,255,255,0.35)",
            }}
          />
        </Box>
        <DatosFacturacion
          cliente={cliente}
          selectorSucursal={selectorSucursal}
          letra={letra}
          BRAND={BRAND}
        />
        <ItemsFormulario
          cliente={cliente}
          selectorSucursal={selectorSucursal}
          letra={letra}
          itemsForm={itemsForm}
          handlePrecioChange={handlePrecioChange}
          leyenda={leyenda}
          setLeyenda={setLeyenda}
          ocs={ocs}
          setOcs={setOcs}
          remitosTexto={remitosTexto}
          confirmar={confirmar}
          facturarDeshabilitado={facturar}
        />
      </Paper>
    </Container>
  );
}
